<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDoubleChevronDown_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m8.531 11.817 3.117-3.116a.623.623 0 1 0-.881-.882L8.09 10.495 5.415 7.82a.623.623 0 1 0-.882.882l3.117 3.116a.623.623 0 0 0 .881 0m.105-3.636 3.117-3.116a.623.623 0 1 0-.882-.882L8.195 6.86 5.519 4.183a.623.623 0 1 0-.882.882L7.754 8.18a.623.623 0 0 0 .882 0"
        clip-rule="evenodd"
    />
</svg>
